// variant-badge.js - v2

(function () {
  'use strict';

  var TRANSLATIONS = {
    fr: {
      // « New » : libellé localisé côté Liquid via les réglages du thème (connec-variant-badge-value.liquid).
      'Sale': 'Solde', 'sale': 'Solde',
      'Hot': 'Populaire', 'hot': 'Populaire',
      'Limited': 'Limite', 'limited': 'Limite',
      'Exclusive': 'Exclusif', 'exclusive': 'Exclusif',
      'Best seller': 'Best-seller', 'best seller': 'Best-seller',
      'Coming soon': 'Bientôt disponible', 'coming soon': 'Bientôt disponible',
      'Web exclusive': 'Exclusif web', 'web exclusive': 'Exclusif web',
      'Back in stock': 'De retour en stock', 'back in stock': 'De retour en stock',
      'Spring 2026': 'Printemps 2026', 'spring 2026': 'Printemps 2026'
    }
  };

  function getLocale() {
    var loc = (window.Shopify && window.Shopify.locale) || document.documentElement.lang || 'en';
    return loc.toLowerCase().split('-')[0];
  }

  function translate(text) {
    var locale = getLocale();
    if (!text || !TRANSLATIONS[locale]) return text;
    var dict = TRANSLATIONS[locale];
    return dict[text.trim()] || dict[text.trim().toLowerCase()] || text;
  }

  function getBadgeForVariant(variantId) {
    var script = document.getElementById('variant-badges-json');
    if (!script) return '';
    try {
      var data = JSON.parse(script.textContent);
      return data[String(variantId)] || '';
    } catch (e) { return ''; }
  }

  function updateBadge(variantId) {
    var wrappers = document.querySelectorAll('[data-variant-badge]');
    if (!wrappers.length) return;

    var metafield = getBadgeForVariant(variantId);
    var parts   = metafield.split('|');
    var rawText = (parts[0] || '').trim();
    // Couleur laissee vide si le metafield n'en precise pas : c'est variant-badge.css qui tranche.
    var color   = (parts[1] || '').trim();
    var text    = translate(rawText);

    wrappers.forEach(function (wrapper) {
      if (text) {
        var badge = wrapper.querySelector('.variant-badge');
        if (!badge) {
          badge = document.createElement('span');
          badge.className = 'variant-badge';
          wrapper.appendChild(badge);
        }
        badge.textContent = text;
        badge.style.backgroundColor = color;
        wrapper.style.display = 'block';
      } else {
        wrapper.style.display = 'none';
      }
    });
  }

  // Appel immediat — pas de setTimeout
  document.addEventListener('variant:change', function (event) {
    var variant = event.detail && event.detail.variant;
    if (!variant || !variant.id) return;
    updateBadge(variant.id);
  });

  // Init au chargement
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.variant-badge').forEach(function (badge) {
      var original = badge.getAttribute('data-original-text') || badge.textContent.trim();
      badge.setAttribute('data-original-text', original);
      badge.textContent = translate(original);
    });

    var variantInput = document.querySelector('form [name="id"]');
    if (variantInput && variantInput.value) updateBadge(variantInput.value);
  });

})();